<template>
    <div class="md-layout mx-3">
      <template v-if="errorMessage">
        <v-alert
            type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="4">
          <v-simple-table
            class="table-layout border-table table-filter-contact"
          >
            <thead>
              <tr>
                <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12)">Tổng chiết khấu</td>
                <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12)">Tổng số contact thắng</td>
                <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12)">Tổng số contact thua</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ formatPrice(totalData.totalDiscount) || 0 }}</td>
                <td>{{ totalData.totalContactWin || 0 }}</td>
                <td>{{ totalData.totalContactLose || 0 }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="4" class="d-flex" style="align-items: flex-end">
          <v-menu
              :internal-activator="true"
              v-model="openMenu"
              content-class="menu__customer--filter no-contain overflow-visible"
              :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-btn style="padding: 0px 25px !important; margin-left: auto" class="" color="primary" dark v-on="on" height="30px" >
                <span>Tìm kiếm đơn hàng đăng ký</span>
                <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <filter-form-dashboard-partner
                :listContactPartnerStatus="listContactStatusPartnerFilter"
                :filterForm="filterForm"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-tabs
          class="mt-0 pl-3"
          @change="changeTab"
          v-model="tabIndex"
          color="primary"
          style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"
      >
        <v-tab v-for="(tab, i) in customerStatusOptions" :key="i+1">{{ tab }}</v-tab>
      </v-tabs>

      <v-simple-table class="table-layout pa-5">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="th-id">STT</th>
            <th>Tên con</th>
            <th>SĐT</th>
            <th>Địa chỉ</th>
            <th>Mã ĐL</th>
            <th>Trạng thái</th>
            <th>Mã đơn</th>
            <th>Sản phẩm mua</th>
            <th v-if="!checkUserInDepartmentType('ctv')">Tổng đơn</th>
            <th>Chiết khấu</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(user, index) in tableData">
            <tr
                :key="user.id"
            >
              <td>{{ index + 1 }}</td>
              <td style="max-width: 300px; word-break: break-all;">{{ _.get(user, 'fullName', '') }}</td>
              <td>{{ _.get(user, 'phone')}}</td>
              <td>{{ _.get(user, 'address') }}</td>
              <td>{{ _.get(user, 'userMarketingName') }}</td>
              <td><span
                  :class="_.get(user, 'statusName') == 'Chờ tư vấn' ? 'highlight-status' : ''">
                  {{ _.get(user, 'statusName') }}</span>
              </td>
              <td>{{ _.get(user, 'order.code') }}</td>
              <td>
                <v-tooltip bottom v-if="(_.get(user, 'order.code', '') && user.products.length) && !checkUserInDepartmentType('ctv')">
                  <template v-slot:activator="{ on }">
                    <v-btn @click="viewProductDetail(user.contactId)" icon small color="black" v-on="on">
                      <v-icon>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>Thông tin cơ bản</span>
                </v-tooltip>
                {{ _.get(user, 'products', []).join(', ') }}
              </td>
              <td v-if="!checkUserInDepartmentType('ctv')">{{ formatPrice(_.get(user, 'order.total', 0)) }}</td>
              <td v-if="tabIndex == 2">{{ formatPrice(_.get(user, 'discount', '120000')) }}</td>
              <td v-else>{{ _.get(user, 'discount', '') }}</td>
            </tr>
          </template>
          </tbody>
        </template>
      </v-simple-table>

      <!-- Pagination -->
      <v-row>
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
          <v-pagination
              v-if="totalItem > limit"
              v-model="currentPage"
              :length="getTotalItem(totalItem, limit)"
              class="justify-sm-end"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
      <modal-orders v-if="filterForm.openModalOrders" :orderList="orderList" :filterForm="filterForm"></modal-orders>
    </div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'
const DashboardPartnerRepository = RepositoryFactory.get('dashboard_partner')
const OrderRepository = RepositoryFactory.get('order')

import FilterFormDashboardPartner from "@/pages/dashboard/components/FilterFormDashboardPartner";
import ModalOrders from "@/pages/dashboard/components/ModalOrders";

export default {
  components: {ModalOrders, FilterFormDashboardPartner},
  data () {
    return {
      tableData: [],
      errorMessage: '',
      loading: false,
      filterForm: {
        name: '',
        phone: '',
        statusIds: [],
        openModalOrders: false
      },
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      customerStatusOptions: [
          'KHÁCH HÀNG ĐĂNG KÝ',
          'KHÁCH HÀNG ĐỒNG Ý MUA',
          'KHÁCH HÀNG MUA THÀNH CÔNG',
      ],
      tabIndex: 0,
      openMenu: false,
      listContactPartnerStatus: [],
      listContactPartnerStatusMap: {},
      orderList: [],
      totalItemOrder: 0,
      listContactStatusPartnerFilter: [],
      totalData: {}
    }
  },
  watch: {
    currentPage: {
      handler () {
        this.fetchTableData()
      },
    },
    limit: {
      handler () {
        if (this.currentPage === 1) {
          this.fetchTableData()
        } else {
          this.currentPage = 1
        }
      },
    },
  },
  mounted () {
    // this.fetchTableData();
    this.fetchContactPartnerStatus();
    this.getDataTotal()
  },
  created() {
    Bus.$on('search-dashboard-partner', () => {
      this.fetchTableData();
      this.openMenu = false;
    })
  },
  methods: {
    changeTab() {
      if (this.tabIndex === 0) {
        this.filterForm.statusIds = [1,2,3];
      } else if (this.tabIndex === 1) {
        this.filterForm.statusIds = [4,5];
      } else if (this.tabIndex === 2) {
        this.filterForm.statusIds = [6];
      }
      this.listContactStatusPartnerFilter = this.listContactPartnerStatus.filter(item => this.filterForm.statusIds.includes(item.id))
      this.currentPage = 1;
      this.fetchTableData();
    },
    search (filterForm) {
      if(filterForm) {
        this.filterForm = filterForm
      }
      this.fetchTableData()
    },

    async fetchTableData () {
      // this.loading = this.$loading.show()
      const response = await DashboardPartnerRepository.list({
        limit: this.limit,
        page: this.currentPage - 1,
        name: this.filterForm.name,
        phone: this.filterForm.phone,
        statusIds: this.filterForm.statusIds,
      })
      if (response.success) {
        this.errorMessage = ''
        this.tableData = _.get(response, 'data').map(item => {
          return {
            ...item,
            statusName: item.isSame ? 'Trùng' : this.listContactPartnerStatusMap[item.partnerStatusId] ? this.listContactPartnerStatusMap[item.partnerStatusId] : '',
          }
        });
        this.totalItem = parseInt(_.get(response, 'totalItem', 0), 10)
      } else {
        this.errorMessage = _.get(response, 'message', '')
      }
      // this.loading.hide()
    },
    async fetchContactPartnerStatus() {
      this.loading = this.$loading.show()
      const response = await DashboardPartnerRepository.listStatus()
      if (response.success) {
        this.listContactPartnerStatus = _.get(response, 'data');
        this.listContactPartnerStatus.forEach(item => {
          this.listContactPartnerStatusMap[item.id] = item.name;
        });
        await this.changeTab();
      } else {
        this.listContactPartnerStatus = []
      }
      this.loading.hide();
    },
    hideLastMobileCharacter(mobile) {
      return mobile.slice(0, -3) + 'xxx';
    },
    async viewProductDetail(contactId) {
      const params = {
        contactId: contactId
      }
      this.loading = true;
      const loader = this.$loading.show();
      const response = await OrderRepository.list(params);
      loader.hide();
      this.loading = false;
      if (response.success) {
        this.orderList = _.get(response, 'data.data', []);
        this.totalItemOrder = response.totalItem;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
        this.orderList = [];
        this.totalItemOrder = 0;
      }
      this.filterForm.openModalOrders = true;
    },
    async getDataTotal() {
      const res = await DashboardPartnerRepository.countTotal()
      if (res.success) {
        this.totalData = _.get(res, 'data', {})
      } else {
        this.totalData = {}
      }
    }
  },
}
</script>

<style scoped>
  .table-layout th {
    min-width: unset !important;
    width: unset !important;
  }
  .highlight-status {
    border: 1px solid;
    padding: 10px;
    border-radius: 20px;
    white-space: nowrap;
  }
  .menu__customer--filter {
    top: 100px !important;
    left: 96% !important;
    transform: translateX(-96%) !important;
  }
</style>
